import { render, staticRenderFns } from "./TeamBuilder.vue?vue&type=template&id=47e2fb57&scoped=true&lang=pug&"
import script from "./TeamBuilder.vue?vue&type=script&lang=js&"
export * from "./TeamBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2fb57",
  null
  
)

export default component.exports